module.exports = __webpack_public_path__ + "img/kwerty-for-writers.4725c44a.svg";